module.exports = __webpack_public_path__ + "static/media/naris.a947db2c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/naris.webp
// module id = 834
// module chunks = 0